import {
    ITCIConnectionsMenuInput,
    ITCIConnectionsMenuOutput,
    TCITenantComponentInput,
    TCITenantComponentOutput
} from "../ng-tenant/tci-tenant-components";
import {
    APPLICATION_SCOPE_TYPE,
    TCI_APP_DETAIL_MENU_TYPE,
    TCI_COMPONENT_MODE,
    ITCIApplicationAuth,
    ITCIConnection,
    ITCITenantComponentOptions,
    ITCIUserInfo,
    ITCIAppFeatureService,
    TCITenantAppType,
    TCITenantSelectorType,
} from "@tci/common";
import { NgUserService } from "../ng-shared/ng-services/ng-user.service";
import { Observable } from "rxjs";

/**
 *
 */
export class BaseConnectionMenuComponentInput extends TCITenantComponentInput
    implements ITCIConnectionsMenuInput {
    /**
     *
     * @param tenantAppType
     * @param componentSelector
     * @param connection
     * @param userService
     * @param featureToggleService
     * @param mode
     * @param componentOption
     * @param leftSubMenuRouteId
     */
    constructor(
        public tenantAppType: TCITenantAppType,
        public componentSelector: TCITenantSelectorType,
        public connection: ITCIConnection,
        public userService: NgUserService,
        public featureToggleService: ITCIAppFeatureService,
        public mode: TCI_COMPONENT_MODE | string,
        public componentOption?: ITCITenantComponentOptions<TCI_APP_DETAIL_MENU_TYPE>,
        public leftSubMenuRouteId?: string) {
        super();
        if (!mode) {
            this.mode = TCI_COMPONENT_MODE.COMP_MODE_APP_DEFAULT;
        }
    }


    getConnection(): ITCIConnection {
        return this.connection;
    }

    getAuthForFunction(scope: APPLICATION_SCOPE_TYPE | string): Observable<ITCIApplicationAuth> {
        return this.userService.getAuthForFunction(scope);
    }

    getUserInfo(): Observable<ITCIUserInfo> {
        return this.userService.getUserInfo(false);
    }

    getFeatureToggleService(): ITCIAppFeatureService {
        return this.featureToggleService;
    }
}

export class BaseConnectionMenuComponentOutput<E extends ITCIConnectionsMenuOutput> extends TCITenantComponentOutput<E> {
    constructor() {
        super();
    }
}
